import React from 'react';

export default function Card({
  children,
  title,
  headerActions,
  padding = 'p-6',
  className = '',
  ...props
}) {
  return (
    <div
      className={`bg-white rounded-xl border border-slate-200 shadow-sm ${padding} ${className}`}
      {...props}
    >
      {(title || headerActions) && (
        <div className="flex items-center justify-between mb-4">
          {title && (
            <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
          )}
          {headerActions && (
            <div className="flex items-center gap-2">{headerActions}</div>
          )}
        </div>
      )}
      {children}
    </div>
  );
}
